import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { language } from "language/default";
import { closeDialog } from "store/messages-dialog";
import { requestAsync } from "redux-query";
import { getConfig } from "plugins/config-loader";
import { normalizeBaseUrl } from "common/string-helper";
const deleteUploadHistoryRaw = (requestParameters, requestConfig = {}) => {
    const baseUrl = normalizeBaseUrl(getConfig("REACT_APP_IDD_BACKEND_BASE_URL") ?? "");
    const config = {
        body: null,
        force: requestConfig.force,
        meta: requestConfig.meta,
        options: {
            method: "DELETE",
            ...requestConfig.options ?? {}
        },
        transform: requestConfig.transform ?? (() => ({})),
        update: requestConfig.update || {
            ImportDataHistories: (prevValue = {}) => {
                const current = prevValue?.[0] ?? [];
                const next = current.filter((item) => item?.id !== requestParameters.id);
                return { ...prevValue, 0: next };
            }
        },
        url: `${baseUrl}/uploadHistory/${encodeURIComponent(String(requestParameters.id))}`
    };
    config.queryKey = requestConfig.queryKey || `DeleteUploadHistory-${requestParameters.id}`;
    return config;
};
export const InsDeleteImportDataDialogAction = () => {
    const dispatch = useDispatch();
    const selectedItem = useSelector((state) => state.messagesDialog?.customProp?.selectedItem);
    const handleDelete = () => {
        if (!selectedItem) {
            return;
        }
        batch(() => {
            const requestConfig = {
                meta: {
                    errorMessage: language.en.administration.dataAdministration.importData.manageData.deleteError,
                    pendingMessage: language.en.administration.dataAdministration.importData.manageData.deletePending,
                    successMessage: language.en.administration.dataAdministration.importData.manageData.deleteSuccess
                }
            };
            dispatch(requestAsync(deleteUploadHistoryRaw({ id: selectedItem }, requestConfig)));
            dispatch(closeDialog());
        });
    };
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "import-data-manage-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: handleDelete }),
        React.createElement(CloseDialogButton, null));
};
